import { render, staticRenderFns } from "./CameraInstructions.vue?vue&type=template&id=63a5ba4d&scoped=true"
import script from "./CameraInstructions.vue?vue&type=script&lang=js"
export * from "./CameraInstructions.vue?vue&type=script&lang=js"
import style0 from "./CameraInstructions.vue?vue&type=style&index=0&id=63a5ba4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5ba4d",
  null
  
)

export default component.exports